import React from "react";
import styled from "styled-components";

export default function VideoURLInput(props) {
  const { value, setValue, placeholder, isEdit } = props;

	function handleChange(e) {
    setValue(e.target.value);
	}

	function handleFocus(e) {
	}

	function handleBlur(e) {
	}

  return (
    <InputView>
      <Input
        placeholder={placeholder}
        value={value}
        type='text'
        disabled={!isEdit}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur} />
    </InputView>
  )
}

const InputView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 10px 10px;

  width: calc(100% - 24px);

  border: 1px solid #CBCBCB;
  border-radius: 14px;
  // background-color: #FFFFFF;
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 17px;

	width: 100%;
	height: 17px;

	padding: 0 0 0 0;
	margin: 0 0 0 0;

	outline: none;
	
	color: #4F4F4F;

  border: none;
  background-color: #F9F9F9;

	::placeholder {
		color: #CBCBCB;
	}
  
  transition: all 0.3s ease-in-out;
`;